import React from 'react';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

const IFRAME_POLL_RATE = 100;

// Simple helper to check if in iframe
export const isInIframe = () => window.self !== window.top;

// eslint-disable-next-line react/prop-types
const IframeHeightUpdateWrapper = BaseComponent => ({ onRef, ...props }) => (
  <div ref={onRef}>
    <BaseComponent {...props} />
  </div>
);

IframeHeightUpdateWrapper.propTypes = {
  onRef: PropTypes.func.isRequired,
};

const withIframeHeightUpdate = compose(
  withState('intervalRef', 'setIntervalRef', null),
  withHandlers(() => {
    let childRef = null;
    let lastHeight = null;
    return {
      onRef: () => (ref) => { childRef = ref; },
      postAppHeightToParent: () => () => {
        if (childRef) {
          const height = childRef.scrollHeight;
          if (lastHeight !== height) {
            window.parent.postMessage({ type: 'setHeight', height }, '*');
            lastHeight = height;
          }
        }
      },
    };
  }),
  lifecycle({
    componentDidMount() {
      const { setIntervalRef } = this.props;
      setIntervalRef(window.setInterval(this.props.postAppHeightToParent, IFRAME_POLL_RATE));
    },
    componentWillUnmount() {
      const { intervalRef } = this.props;
      clearInterval(intervalRef);
    },
  }),
);

withIframeHeightUpdate.propTypes = {
  onRef: PropTypes.func.isRequired,
};

export default BaseComponent => withIframeHeightUpdate(IframeHeightUpdateWrapper(BaseComponent));



// WEBPACK FOOTER //
// ./src/hoc/withIframeHeightUpdate.js